import React, { useState } from "react";
import { Button, Card, message } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { ethers } from "ethers";
import CryptoJS from "crypto-js";
import WalletBackground from "../components/WalletBackground";
import BaitLogo from "../BaitLogo.png";
import {
  CopyOutlined,
  CheckCircleFilled,
} from "@ant-design/icons";

import "../components/Header.css";

function CreateAccount({ setWallet, setSeedPhrase }) {
  const [newSeedPhrase, setNewSeedPhrase] = useState(null);
  const [privateKey, setPrivateKey] = useState(null);
  const [address, setAddress] = useState(null);
  const [copied, setCopied] = useState(false);
  const navigate = useNavigate();

  function generateWallet() {
    const wallet = ethers.Wallet.createRandom();
    const mnemonic = wallet.mnemonic.phrase;
    const privKey = wallet.privateKey;
    const addr = wallet.address;

    const password = "wallet-access-key";

    const encryptedPrivateKey = CryptoJS.AES.encrypt(
      privKey,
      password
    ).toString();

    localStorage.setItem("seedPhrase", mnemonic);
    localStorage.setItem("encryptedPrivateKey", encryptedPrivateKey);
    localStorage.setItem("address", addr);

    setNewSeedPhrase(mnemonic);
    setPrivateKey(privKey);
    setAddress(addr);
  }

  function setWalletAndMnemonic() {
    if (newSeedPhrase) {
      setSeedPhrase(newSeedPhrase);
      setWallet(address);
      navigate("/yourwallet");
    }
  }

  const copySeedPhrase = async () => {
    if (!newSeedPhrase) return;

    try {
      await navigator.clipboard.writeText(newSeedPhrase);

      setCopied(true);
      message.success("Seed phrase copied");

      setTimeout(() => {
        setCopied(false);
      }, 2000);
    } catch (err) {
      message.error("Unable to copy");
    }
  };

  return (
    <div className="content">
      <WalletBackground />

      {/* ==================== HEADER (bigger logo + text) ==================== */}
      <div
        className="wallet-header-brand"
        style={{
          marginBottom: "28px",
          gap: "20px",
          maxWidth: "100%",
        }}
      >
        <div
          className="brand-coin-wrap"
          style={{
            width: "96px",
            height: "96px",
            minWidth: "96px",
            minHeight: "96px",
          }}
        >
          <div className="brand-coin-glow" aria-hidden="true" />
          <img
            src={BaitLogo}
            alt="BAIT PAY"
            className="brand-coin"
            style={{
              width: "96px",
              height: "96px",
            }}
          />
        </div>

        <div className="brand-text">
          <span
            className="brand-title"
            style={{
              fontSize: "38px",
              letterSpacing: "2.2px",
              lineHeight: 1.05,
            }}
          >
            BAIT PAY
          </span>
          <span
            className="brand-tagline"
            style={{
              fontSize: "13px",
              letterSpacing: "4.5px",
              marginTop: "4px",
            }}
          >
            DIGITAL GOLD
          </span>
        </div>
      </div>

      <div className="mnemonic">
        <ExclamationCircleOutlined style={{ fontSize: "20px" }} />

        <div>
          Once you generate the seed phrase, save it securely to recover your
          wallet in the future.
        </div>
      </div>

      <Button
        className="frontPageButton"
        type="primary"
        onClick={generateWallet}
      >
        Generate Seed Phrase
      </Button>

      <Card className="seedPhraseContainer">
        {newSeedPhrase && (
          <div className="copySeedIcon" onClick={copySeedPhrase}>
            {copied ? (
              <CheckCircleFilled className="copied" />
            ) : (
              <CopyOutlined />
            )}
          </div>
        )}

        {newSeedPhrase && <pre>{newSeedPhrase}</pre>}
      </Card>

      <Button
        className="frontPageButton"
        type="default"
        onClick={setWalletAndMnemonic}
      >
        Open Your New Wallet
      </Button>

      <p className="frontPageBottom" onClick={() => navigate("/")}>
        Back Home
      </p>
    </div>
  );
}

export default CreateAccount;